<template>
	<div>

        <el-card shadow="never">
            <el-row class="app-btn-group" :gutter="10">
                <el-col :span="3">
                    <el-select
                    :placeholder="$t('submit_time')"
                    size="medium" 
                    clearable style="width: 100%" 
                    v-model="searchTime">
                        <el-option
                            v-for="s in timeList"
                            :key="s.time"
                            :label="s.label"
                            :value="s.time">
                        </el-option>
                    </el-select>
                 </el-col>
                <el-col :span="3">
                    <el-select
                    :placeholder="$t('audit_status')"
                    size="medium" 
                    clearable 
                    style="width: 100%" 
                    v-model="searchAuditStatus">
                        <el-option
                            v-for="s in auditStatusList"
                            :key="s.status"
                            :label="s.label"
                            :value="s.status">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <el-select
                    :placeholder="$t('command_status')"
                    size="medium" 
                    clearable 
                    style="width: 100%" 
                    v-model="searchStatus">
                        <el-option
                            v-for="s in statusList"
                            :key="s.status"
                            :label="s.label"
                            :value="s.status">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :span="9">
                    <el-select
                    :placeholder="$t('select_template')"
                    size="medium" 
                    clearable 
                    style="width: 100%" 
                    v-model="searchTemplateId">
                        <el-option
                        v-for="p in templateList"
                        :key="p.template_id"
                        :label="p.template_name"
                        :value="p.template_id">
                            {{p.space_name}} <i class="el-icon-arrow-right"></i> {{p.template_name}}
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <el-input @keyup.enter.native="searchHandler" v-model="searchInput" size="medium" :placeholder="$t('please_input_keyword_id_or_name')">
                        <el-button @click="searchHandler" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>
            </el-row>



            <el-table
                class="app-table"
                size="medium"
                v-loading="tableLoading"
                :data="tableData">
                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                <el-table-column prop="name" :label="$t('name')"></el-table-column>
                <el-table-column :label="$t('command_template_name')">
                    <template slot-scope="scope">
                         {{ scope.row.template_name }}
                         <el-tooltip effect="dark" :content="$t('belong_to_space') + ': ' + scope.row.space_name" placement="top">
                            <span class="app-cursor"><i class="iconfont icon-space"></i></span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="ssh_port" width="100" :label="$t('submit_time')">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="$root.FormatDateTime(scope.row.ctime)" placement="top">
                            <span class="app-cursor">{{ $root.FormatDateFromNow(scope.row.ctime) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="ssh_port" width="100" :label="$t('submiter')">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="scope.row.username" placement="top">
                            <span class="app-cursor">{{ scope.row.username }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="audit_status" width="100" :label="$t('audit')">
                    <template slot-scope="scope">
                        <span class="app-color-warning" v-if="scope.row.audit_status == $root.AuditStatusPending">{{ $t('unaudit') }}</span>
                        <span class="app-color-success" v-else-if="scope.row.audit_status == $root.AuditStatusOk">{{ $t('pass') }}</span>
                        <span class="app-color-error" v-else-if="scope.row.audit_status == $root.AuditStatusRefuse">{{ $t('denied') }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" width="100" :label="$t('status')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == $root.ApplyStatusNone"><i class="iconfont small left icon-wait"></i>{{ $t('wait_online') }}</span>
                        <span v-else-if="scope.row.status == $root.ApplyStatusIng"><i class="iconfont small left icon-coffee"></i>{{ $t('onlineing') }}</span>
                        <span class="app-color-success" v-else-if="scope.row.status == $root.ApplyStatusSuccess"><i class="iconfont small left icon-success"></i>{{ $t('success') }}</span>
                        <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusFailed"><i class="iconfont small left icon-failed"></i>{{ $t('failed') }}</span>
                        <span class="app-color-gray" v-else-if="scope.row.status == $root.ApplyStatusDrop"><i class="iconfont small left icon-drop"></i>{{ $t('drop') }}</span>
                        <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusRollback"><i class="iconfont small left icon-rollback"></i>{{ $t('rollback') }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('operate')" width="100" align="right">
                    <template slot-scope="scope">
                        <el-dropdown trigger="click" @command="operateHandler($event, scope.row)">
                            <el-button size="small">
                                {{ $t('operate') }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu class="app-op-dropdown" slot="dropdown">
                                <el-dropdown-item command="view" v-if="$root.CheckPriv($root.Priv.COMMAND_OPERATE_VIEW)">
                                    <i class="iconfont left small icon-view"></i>{{ $t('view') }}
                                </el-dropdown-item>
                                <el-dropdown-item command="edit" 
                                v-if="scope.row.status == $root.ApplyStatusNone && (scope.row.audit_status == $root.AuditStatusPending || scope.row.audit_status == $root.AuditStatusRefuse) && $root.CheckPriv($root.Priv.COMMAND_OPERATE_EDIT)">
                                    <i class="iconfont left small icon-edit"></i>{{ $t('edit') }}
                                </el-dropdown-item>
                                <el-dropdown-item command="audit"
                                v-if="scope.row.audit_status == $root.AuditStatusPending && scope.row.status == $root.ApplyStatusNone && $root.CheckPriv($root.Priv.COMMAND_OPERATE_AUDIT)">
                                    <i class="iconfont left small icon-audit"></i>{{ $t('audit') }}
                                </el-dropdown-item>
                                <el-dropdown-item command="execute"
                                v-if="scope.row.audit_status == $root.AuditStatusOk && (scope.row.status == $root.ApplyStatusNone || scope.row.status == $root.ApplyStatusIng || scope.row.status == $root.ApplyStatusSuccess || scope.row.status == $root.ApplyStatusFailed || scope.row.status == $root.ApplyStatusRollback) && $root.CheckPriv($root.Priv.COMMAND_OPERATE_EXECUTE)">
                                    <i class="iconfont left small icon-coffee"></i>{{ $t('online') }}
                                </el-dropdown-item>
                                <el-dropdown-item command="drop"
                                v-if="scope.row.status != $root.ApplyStatusIng && scope.row.status != $root.ApplyStatusDrop && $root.CheckPriv($root.Priv.COMMAND_OPERATE_DROP)">
                                    <i class="iconfont left small icon-drop"></i>{{ $t('drop') }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                class="app-pagination"
                @current-change="currentChangeHandler"
                :current-page.sync="$root.Page"
                :page-size="$root.PageSize"
                :total="$root.Total">
            </el-pagination>
        </el-card>

        <!-- 查看模态框 -->
        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        @close="closeDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form size="medium" label-width="120px">
                    <el-form-item :label="$t('space_name')">
                        {{ dialogDetail.space_name }}
                    </el-form-item>
                    <el-form-item :label="$t('command_template_name')">
                        {{ dialogDetail.template_name }}
                    </el-form-item>
                    <el-form-item :label="$t('command_name')">
                        {{ dialogDetail.name }}
                    </el-form-item>
                    <el-form-item :label="$t('command_mode')">
                        <div v-if="dialogDetail.tmode == 1">
                            <i class="iconfont icon-branch"></i> {{ this.$t('tpl_mode') }}
                        </div>
                        <div v-else>
                            <i class="iconfont icon-tag"></i> {{ this.$t('flow_mode') }}
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('command_illustrate')">
                        {{ dialogDetail.description }}
                    </el-form-item>
                    <el-form-item :label="$t('audit_status')">
                        {{ this.auditStatusTitle(dialogDetail.audit_status) }}
                    </el-form-item>
                    <el-form-item :label="$t('submiter')">
                        {{ dialogDetail.username }}
                    </el-form-item>
                    <el-form-item :label="$t('submit_time')">
                        {{ this.$root.FormatDateTime(dialogDetail.ctime) }}
                    </el-form-item>

                    <template v-if="dialogDetail.cmd == 'audit'">
                        <el-form-item :label="$t('audit')" v-if="dialogDetail.status == $root.ApplyStatusNone && dialogDetail.audit_status == $root.AuditStatusPending">
                            <div>
                                <el-radio v-model="auditStatus" :label="$root.AuditStatusOk"><span class="app-color-success">{{ $t('audit_pass') }}</span></el-radio>
                                <el-radio v-model="auditStatus" :label="$root.AuditStatusRefuse"><span class="app-color-error">{{ $t('audit_denied') }}</span></el-radio>
                            </div>
                        </el-form-item>
                        <el-form-item :label="$t('deined_reason')" v-if="dialogDetail.status == $root.ApplyStatusNone && dialogDetail.audit_status == $root.AuditStatusPending && auditStatus == $root.AuditStatusRefuse">
                            <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="auditRefusalReason"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="dialogSubmitAuditStatusHandler">{{ $t('audit') }}</el-button>
                            <el-button size="small" @click="closeDialogHandler">{{ $t('close') }}</el-button>
                        </el-form-item>
                    </template>  
                </el-form>
            </div>
        </el-dialog>

        <!-- 编辑模态框 -->
        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="dialogTitle"
        :visible.sync="dialogEditVisible"
        @close="closeEditDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form 
                class="app-form" 
                ref="dialogRef" 
                :model="dialogForm" 
                size="medium" 
                label-width="130px">
                    <el-form-item
                    :label="$t('command_template_name')">
                        {{ dialogForm.template_name }}
                    </el-form-item>
                    <el-form-item 
                    :label="$t('command_name')">
                        {{ dialogForm.name}}
                    </el-form-item>
                    <el-form-item :label="$t('command_mode')">
                        <span v-if="dialogForm.tmode == 1">
                            <i class="iconfont icon-branch"></i> - {{ $t('tpl_mode') }}
                        </span>
                        <span v-if="dialogForm.tmode == 2">
                            <i class="iconfont icon-tag"></i> {{ $t('flow_mode') }}
                        </span>
                    </el-form-item>

                    <el-form-item 
                    :label="$t('command_illustrate')"
                    prop="description"
                    :rules="[
                        { required: true, message: $t('command_illustrate_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :rows="4" type="textarea" :placeholder="$t('please_input_command_illustrate')" v-model="dialogForm.description" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeEditDialogHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="dialogBtnLoading" size="small" type="primary" @click="dialogSubmitEditHandler">{{ $t('enter') }}</el-button>
                </div>
            </div>
        </el-dialog>

       

	</div>
</template>

<script>
import {
    OperateListApi,
    OperateUpdateApi,
    OperateDeleteApi, 
    TemplateAllApi,
    OperateDetailApi,
    OperateDropApi,
    OperateAuditStatusUpdateApi,
} from '@/api/command.js'

import {
    detailSpaceApi,
    listSpaceApi,
} from '@/api/project.js'

export default {
    data() {
        return {
            dialogVisible: false,
            dialogEditVisible: false,
            dialogTitle: '',
            dialogSpaceVisible: false,
            searchInput: '',
            spaceList: [],
            clusterList: [],
            tableLoading: false,
            tableData: [],
            spaceId: undefined,
            searchAuditStatus: '',
            searchStatus:'',
            searchTemplateId:'',
            templateList: [],
            searchTime: '',
            auditStatus: 2,
            auditRefusalReason: '',
            dialogForm: {
                id: 0,
                name: '',
                description: '',
                tmode: 1,
                template_name:'',
                status: 0,
            },
            
            dialogDetail:{
                name: '',
                space_name: '',
                tmode: 1,
                template_name: '',
                flow_name: '',
                username: '',
                audit_status: 0,
                description: '',
                ctime: '',
                cmd: '',
                status: 1,
            },

            timeList: [
                {time: 1, label: this.$t('today')},
                {time: 7, label: this.$t('7day')},
                {time: 30, label: this.$t('within_one_month')},
                {time: 90, label: this.$t('within_three_months')},
                {time: 365, label: this.$t('within_a_year')},
                {time: 0, label: this.$t('any_time')},
            ],
            statusList: [
                {status: this.$root.ApplyStatusNone, label: this.$t('not_execute')},
                {status: this.$root.ApplyStatusIng, label: this.$t('executing')},
                {status: this.$root.ApplyStatusSuccess, label: this.$t('execute_success')},
                {status: this.$root.ApplyStatusFailed, label: this.$t('execute_failed')},
                {status: this.$root.ApplyStatusDrop, label: this.$t('deprecated')},
            ],
            auditStatusList: [
                {status: this.$root.AuditStatusPending, label: this.$t('unaudit')},
                {status: this.$root.AuditStatusOk, label: this.$t('audit_pass')},
                {status: this.$root.AuditStatusRefuse, label: this.$t('audit_denied')},
            ],

            spaceDetail: {},
        }
    },

    methods: {
        loadTableData() {
            this.tableLoading = true
            let query = {
                keyword : this.searchInput,
                time: this.searchTime,
                audit_status: this.searchAuditStatus,
                status: this.searchStatus,
                template_id: this.searchTemplateId,
                offset: this.$root.PageOffset(),
                limit: this.$root.PageSize,
            }
            OperateListApi(query).then(res => {
                this.tableData = res.list
                this.$root.Total = res.total
                this.tableLoading = false
            }).catch(err => {
                this.tableLoading = false
            })
        },

        operateHandler(cmd, row) {
            switch(cmd) {
                case 'view':
                    this.viewHandler(cmd, row)
                    break
                case 'edit':
                    this.editHandler(cmd, row)
                    break
                case 'audit':
                    this.auditHandler(cmd, row)
                    break
                case 'drop':
                    this.dropHandler(cmd, row)
                    break
                case 'execute':
                    this.executeHandler(cmd, row)
                    break
            }
        },

        viewHandler(cmd, row) {
            this.dialogLoading = true
            OperateDetailApi({id: row.id}).then(detail => {
                this.dialogLoading = false
                this.dialogDetail = detail
                this.openDialogHandler(cmd == 'view' ? this.$t('view') : this.$t('audit'))
            }).catch(err => {
                this.dialogLoading = false
            })
        },
        editHandler(cmd, row){
            this.dialogLoading = true
            OperateDetailApi({id: row.id}).then(detail => {
                this.dialogLoading = false
                this.dialogDetail = detail
                this.dialogForm = {
                    id: row.id,
                    template_name: detail.template_name,
                    name: detail.name,
                    tmode: detail.tmode,
                    description:  detail.description,
                }
                this.openEditDialogHandler(cmd == 'edit' ? this.$t('edit') : this.$t('audit'))
            }).catch(err => {
                this.dialogLoading = false
            })  
        },
        auditHandler(cmd, row){
            this.dialogLoading = true
            OperateDetailApi({id: row.id}).then(detail => {
                this.dialogLoading = false
                this.dialogDetail = detail
                this.dialogDetail.cmd = cmd
                this.dialogForm = {
                    id: row.id,
                }
                this.openDialogHandler(cmd == 'view' ? this.$t('view') : this.$t('audit'))
            }).catch(err => {
                this.dialogLoading = false
            })
        },
        dropHandler(cmd, row) {
            this.$root.ConfirmDelete(() => {
                OperateDropApi({id: row.id}).then(res => {
                    this.loadTableData()
                })
            }, this.$t('drop_deploy_apply_tips'))
        },
        executeHandler(cmd, row) {
            this.$router.push({name: 'operateRelease', query: { id: row.id}})
        },
        openDialogHandler(title) {
            this.dialogTitle = title
            this.dialogVisible = true
        },
        openEditDialogHandler(title){
            this.dialogTitle = title
            this.dialogEditVisible = true
        },
        closeDialogHandler(){
            this.dialogVisible = false
        },
        closeEditDialogHandler(){
            this.dialogEditVisible = false
            this.dialogForm = {}
            this.dialogLoading = false
        },

        dialogSubmitEditHandler() {
            this.$refs.dialogRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.btnLoading = true
                let postData = {
                    id: this.dialogForm.id,
                    description: this.dialogForm.description,
                }
                OperateUpdateApi(postData).then(res => {
                    this.$alert(this.$t('command_apply_submit_success'), this.$t('submit_success'), {
                        type: 'success',
                        confirmButtonText: this.$t('enter'),
                        callback: action => {
                            this.closeEditDialogHandler()
                        }
                    })
                    this.btnLoading = false
                }).catch(err => {
                    this.btnLoading = false
                })
            })
        },
        dialogSubmitAuditStatusHandler(){

            this.btnLoading = true
            let postData = {
                id: this.dialogForm.id,
                audit_status: this.auditStatus,
                audit_refusal_reason: this.auditRefusalReason,
            }
            OperateAuditStatusUpdateApi(postData).then(res => {
                this.$alert(this.$t('command_apply_submit_success'), this.$t('submit_success'), {
                    type: 'success',
                    confirmButtonText: this.$t('enter'),
                    callback: action => {
                        this.closeDialogHandler()
                        this.loadTableData()
                    }
                })
                this.btnLoading = false
            }).catch(err => {
                this.btnLoading = false
            })  
        },

        auditStatusTitle(auditStatus) {
            let auditTitle = ''
            this.auditStatusList.forEach(item => {
                if (auditStatus == item.status) {
                    auditTitle = item.label
                }
            })
            return auditTitle
        },


        dialogCloseHandler() {
            this.dialogVisible = false
            this.dialogLoading = false
            this.btnLoading = false
            this.$refs.dialogRef.resetFields();
            this.dialogForm = {}
        },
        currentChangeHandler() {
            this.loadTableData()
        },

        loadTemplateAll() {
            TemplateAllApi().then(res => {
                if (res && res.length > 0 ) {
                    this.templateList = res
                }
            })
        },
        searchHandler() {
            this.$root.PageInit()
            this.loadTableData()
        },

    },

    mounted() {
        this.$root.PageInit()
        this.loadTemplateAll()
        this.loadTableData()
    }

}
</script>
